import React from 'react';
import {
  Container, Dimmer, Table, Card,
  Button, Page
} from "tabler-react";
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload,
  searchQuery,
  onSearch
}) => {
  return (
    <Container>
      <Page.Header>
        <Page.Title>Message</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('message-create', null, reload)}
              >
                Create Message
              </Button>
            </Card.Options>
          </Card.Header>
          {!loading && records.length < 1 ?
            <div className="alert alert-primary m-0">
              No Message to show!
            </div>
            :
            <Table
              hasOutline
              striped
            >
              <Table.Header>
                {headers.map((head, i) => (
                  <Table.ColHeader
                    key={`tableHeader-${i}`}
                  >
                    {head}
                  </Table.ColHeader>
                ))}
                <Table.ColHeader>Actions</Table.ColHeader>
              </Table.Header>
              <Table.Body>
                {records.map((r, i) => (
                  <Table.Row key={i}>
                    {Object.keys(r).map((k, i) => {
                      if (k === 'id') { return false }
                      else if (k === 'answers') {
                        return (<Table.Col>
                          <p>{r['answers'].toString()}</p>
                        </Table.Col>
                        )
                      }
                      else if (k === 'targets') {
                        return (<Table.Col>
                          <p>{r['targets'].toString()}</p>
                        </Table.Col>
                        )
                      }
                      else {
                        return (<Table.Col>{r[k]}</Table.Col>);
                      }
                    })}
                    <Table.Col>
                      <Button
                        outline
                        color="secondary"
                        icon=""
                        size="sm"
                        onClick={() => openMainModal('message-edit', r.id, reload)}
                      >
                        Edit
                      </Button>

                      <Button
                        outline
                        color="danger"
                        icon=""
                        className="ml-2"
                        size="sm"
                        onClick={() => openMainModal('message--delete', r.id, reload)}
                      >
                        Delete
                      </Button>
                    </Table.Col>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          }
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;